// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter, Update } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';
import { FacilityModel } from '../_models/facility.model';
import { FacilityActionTypes, FacilityActions } from '../_actions/facility.actions';

export interface FacilitiesState extends EntityState<FacilityModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedFacilityId: number;
  lastCreatedFacility: FacilityModel;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
  error: any | null;
}

export const adapter: EntityAdapter<FacilityModel> = createEntityAdapter<FacilityModel>();
export const initialFacilitiesState: FacilitiesState = adapter.getInitialState({
  FacilityForEdit: null,
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  lastCreatedFacilityId: undefined,
  lastCreatedFacility: undefined,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
  error: null,
});

export function facilitiesReducer(
  state = initialFacilitiesState,
  action: FacilityActions,
): FacilitiesState {
  switch (action.type) {
    case FacilityActionTypes.FacilitiesPageToggleLoading: {
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedFacilityId: undefined,
      };
    }
    case FacilityActionTypes.FacilityActionToggleLoading: {
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    }
    case FacilityActionTypes.FacilityOnServerCreated:
      return {
        ...state,
      };
    case FacilityActionTypes.FacilityCreated:
      return adapter.addOne(action.payload.facility, {
        ...state,
        lastCreatedFacilityId: action.payload.facility.id,
        lastCreatedFacility: action.payload.facility,
      });
    case FacilityActionTypes.FacilityUpdated:
      return adapter.updateOne(action.payload.partialFacility, state);
    case FacilityActionTypes.FacilityStatusUpdated: {
      // tslint:disable-next-line
      const _partialFacility: Update<FacilityModel> = {
        id: action.payload.facility.id,
        changes: {
          is_active: action.payload.is_active,
        },
      };
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      return adapter.updateOne(_partialFacility, state);
    }
    case FacilityActionTypes.FacilitiesStatusUpdated: {
      // tslint:disable-next-line
      const _partialFacilities: Update<FacilityModel>[] = [];
      // tslint:disable-next-line:prefer-const
      // tslint:disable-next-line
      for (let i = 0; i < action.payload.facilities.length; i++) {
        _partialFacilities.push({
          id: action.payload.facilities[i].id,
          changes: {
            is_active: action.payload.is_active,
          },
        });
      }
      return adapter.updateMany(_partialFacilities, state);
    }
    case FacilityActionTypes.OneFacilityDeleted:
      return adapter.removeOne(action.payload.id, state);
    case FacilityActionTypes.ManyFacilitiesDeleted:
      return adapter.removeMany(action.payload.ids, state);
    case FacilityActionTypes.FacilitiesPageCancelled: {
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    }
    case FacilityActionTypes.FacilitiesPageLoaded: {
      return adapter.addMany(action.payload.facilities, {
        ...initialFacilitiesState,
        totalCount: action.payload.totalCount,
        listLoading: false,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
      });
    }
    case FacilityActionTypes.ThrowFacilityError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case FacilityActionTypes.ClearFacilityErrors: {
      return {
        ...state,
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getFacilityState = createFeatureSelector<FacilityModel>('facilities');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
